export const REPOSITORY_INDEXING_MODE_VALUES = [
  "embedding_and_indexing",
  "embedding_only",
  "indexing_only",
] as const;

export type RepositoryIndexingMode =
  (typeof REPOSITORY_INDEXING_MODE_VALUES)[number];

export const DEFAULT_REPOSITORY_INDEXING_MODE =
  "embedding_and_indexing" as const satisfies RepositoryIndexingMode;

export const REPOSITORY_INDEXING_AI_PROVIDER_VALUES = [
  "anthropic",
  "bedrock",
  "google",
  "openai",
  "vertex",
] as const;

export type RepositoryIndexingAiProvider =
  (typeof REPOSITORY_INDEXING_AI_PROVIDER_VALUES)[number];

const ALL_INDEXING_AI_PROVIDERS =
  REPOSITORY_INDEXING_AI_PROVIDER_VALUES satisfies readonly RepositoryIndexingAiProvider[];

export function parseRepositoryIndexingMode(
  value: unknown,
): RepositoryIndexingMode | null {
  if (typeof value !== "string") {
    return null;
  }
  const normalized = value.trim().toLowerCase();
  switch (normalized) {
    case "embedding_and_indexing":
    case "embedding_only":
    case "indexing_only": {
      return normalized;
    }
    default: {
      return null;
    }
  }
}

export function requiresRepositoryEmbedding(
  mode: RepositoryIndexingMode,
): boolean {
  return mode !== "indexing_only";
}

export function requiresRepositoryProfileIndexing(
  mode: RepositoryIndexingMode,
): boolean {
  return mode !== "embedding_only";
}

export function getRequiredAiProvidersForRepositoryIndexingMode(
  mode: RepositoryIndexingMode,
): readonly RepositoryIndexingAiProvider[] {
  return requiresRepositoryProfileIndexing(mode)
    ? ALL_INDEXING_AI_PROVIDERS
    : ["google"];
}
